'use client'

import HouseFacility from '@component/card/listings/facility'
import ImageBgLoading from '@component/imageBgLoading'
import useEnquiry from '@hooks/useEnquiry'
import useViewAll from '@hooks/useViewAll'
import classNames from 'classnames'
import { get, map, size } from 'lodash-es'

export default function DisplayHome({
  data,
  builder,
  className
}) {

  const [viewOpenHours, ToggleButton, displayAll] = useViewAll(get(data, 'openHours', []), 3)
  const { showDisplayHomeEnquiry } = useEnquiry()

  return (
    <div className={classNames('min-w-0 bg-neutral-1', className)}>
      <div className='relative'>
        <ImageBgLoading src={get(data, 'ossImages.0', '')} width={300} height={150} className='aspect-[2/1] block w-full h-auto' alt={data.title}></ImageBgLoading>
        <div className=' absolute inset-x-0 inset-y-0 p-16 flex items-end bg-image-mask-sm'>
          <HouseFacility data={data} itemClassName='text-white'></HouseFacility>
        </div>
      </div>
      <div className='p-10 space-y-10 flex-1 min-h-0'>
        <div className='text-sm text-secondary'>{data.title}</div>
        <div className='text-sm text-font'>{data.address}</div>
        {
          size(viewOpenHours) > 0 && (
            <div>
              <div className='text-font-secondary2 text-sm'>OPEN HOURS</div>
              <div className='space-y-4 mt-4'>
                {
                  map(viewOpenHours, (item, idx) => (
                    <div key={idx} className='text-sm grid grid-cols-2'>
                      <span>{item.weekDay}</span>
                      <span>{item.label}</span>
                    </div>
                  ))
                }
              </div>
              {
                !displayAll && <ToggleButton showAllLabel='View all hours' className='button-text-primary'></ToggleButton>
              }
            </div>
          )
        }
      </div>
      {
        data.email && <button type='button' className='button-primary w-full !rounded-none' onClick={showDisplayHomeEnquiry({ displayHome: data, builder })}>Get in Touch</button>
      }
    </div>
  )
}

export function SkeletonCard() {
  return (
    <div className='skeleton-wrap space-y-6'>
      <span className='aspect-[2/1]'></span>
      <span className='h-20'></span>
      <span className='h-10 w-1/3'></span>
    </div>
  )
}